<div class="ui-virtual-calculator">
  <form [formGroup]="form">
    <input
      formControlName="quantity"
      matInput
      type="text"
      class="lum-input ui-virtual-calculator__input text-right w-100"
    />

    <mat-grid-list class="mt-4" cols="4" rowHeight="65px" gutterSize="4px">
      <mat-grid-tile *ngFor="let number of virtualNumbers">
        <button
          (click)="onAppendToInput(number)"
          class="ui-virtual-calculator__button w-100"
          mat-button
        >
          {{ number }}
        </button>
      </mat-grid-tile>
      <mat-grid-tile>
        <button
          class="ui-virtual-calculator__button--backspace w-100"
          mat-button
          (click)="onBackspaceClick()"
        >
          <i class="fas fa-arrow-left mr-2"></i>
        </button>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</div>
